exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modelingLegendModal .v--modal-box.v--modal{min-height:250px!important;min-width:400px!important;max-width:450px!important;max-height:300px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65cea0be","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/ModelingLegend.vue
// module id = 1832
// module chunks = 0